function find_parent(child_element, class_name) {
	const parent = child_element.parentElement;
	if (parent.classList.contains(class_name)) {
		return parent;
	}
	return find_parent(parent, class_name);
}

function remove_card(event) {
	event.preventDefault();
	const submit_button = this.querySelector('input[type="submit"].button');
	submit_button.innerHTML = 'Removing...';
	const $body_data = new FormData(this);
	fetch(remove_card_vars.ajaxurl, {
		method: 'POST',
		headers: {
			'X-JS-Request': 'true',
		},
		body: $body_data,
	})
		.then((response) => response.json())
		.then((response) => {
			let element_to_append_after = document.getElementById('your_cards_title');
			const temp = document.createElement('div');
			temp.innerHTML = response.data;
			for (let i = 0; i < temp.children.length; i++) {
				element_to_append_after.parentNode.insertBefore(
					temp.children[i],
					element_to_append_after.nextSibling
				);
				element_to_append_after = element_to_append_after.nextSibling;
			}
			if (response.success) {
				this.removeEventListener('submit', remove_card);
				const card_parent = find_parent(this, 'card');
				card_parent.remove();
				if (document.getElementById('card_list').children.length === 0) {
					const card_list = document.getElementById('card_list'),
						no_cards = document.createElement('p');
					no_cards.classList.add('no-cards');
					no_cards.innerHTML =
						'You have no card details stored with us right now, you can add a card below.';
					card_list.parentNode.replaceChild(no_cards, card_list);
				}
			}
		});
}

wp.domReady(function () {
	const remove_card_forms = document.getElementsByClassName('remove_card_form');
	if (remove_card_forms.length > 0) {
		for (let $i = 0; $i < remove_card_forms.length; $i++) {
			remove_card_forms[$i].addEventListener('submit', remove_card);
		}
	}
});
